import { useEffect } from 'react';

import useHistory from 'routing/useHistory';

import SymantecSESRoutes from './Routes';

type Props = { url: string };

// https://stackoverflow.com/questions/52912238/render-methods-should-be-a-pure-function-of-props-and-state

const SymantecSESInputConfiguration: React.FC<Props> = (
) => {
  const history = useHistory();

  useEffect(() => {
    const url = SymantecSESRoutes.INTEGRATIONS.SymantecSES.ACTIVITYAPI.index;
    history.push(url);
  }, [history]);

  return null;
};

export default SymantecSESInputConfiguration;
